var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4901 7.50032H3.51757C2.40757 7.50032 1.50757 6.59282 1.50757 5.49032V3.51782C1.50757 2.40782 2.41507 1.50781 3.51757 1.50781H14.4901C15.6001 1.50781 16.5001 2.41532 16.5001 3.51782V5.49032C16.5001 6.59282 15.5926 7.50032 14.4901 7.50032Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4901 16.5003H3.51757C2.40757 16.5003 1.50757 15.5928 1.50757 14.4903V12.5178C1.50757 11.4078 2.41507 10.5078 3.51757 10.5078H14.4901C15.6001 10.5078 16.5001 11.4153 16.5001 12.5178V14.4903C16.5001 15.5928 15.5926 16.5003 14.4901 16.5003Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75V5.25",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75V5.25",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.75V14.25",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.75V14.25",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5H13.5",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5H13.5",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.f68342076b5d4ea784f2ac4a51eebd80.svg";
export { ForwardRef as ReactComponent };